import "./Reservations.css"
import { Link } from "react-router-dom"
function Reservations(){
  const gettop=()=>{
    window.scrollTo({
      top:0,
      behavior:"smooth"
    })
  }
    return(
        <>
        <div className="Reservations">
           <div className="continer">
  <h3>Book Your Appointment Now at Medora Medical Center</h3>
  <p>
    We provide you with the finest medical services, led by a distinguished team of specialized doctors. 
    Log in today to easily and conveniently schedule your appointment.
  </p>
</div>
<div className="content">
    <div className="row g-2 m-2">
  <div className="col-md-4">
    <div className="box">
      <i className="fas fa-calendar-alt"></i>
      <h4>Flexible Appointments</h4>
      <h5>Choose the time that suits you</h5>
    </div>
  </div>

  <div className="col-md-4">
    <div className="box">
      <i className="fas fa-user-md"></i>
      <h4>Specialized Doctors</h4>
      <h5>A distinguished team across all specialties</h5>
    </div>
  </div>

  <div className="col-md-4">
    <div className="box">
      <i className="fas fa-microscope"></i>
      <h4>Advanced Technology</h4>
      <h5>Latest medical equipment and innovations</h5>
    </div>
  </div>

  <div className="col-md-4">
    <div className="box">
      <i className="fas fa-star"></i>
      <h4>Exceptional Service</h4>
      <h5>Comprehensive care with top quality </h5>
    </div>
  </div>

  {/* Extra 6 boxes */}
  <div className="col-md-4">
    <div className="box">
      <i className="fas fa-heartbeat"></i>
      <h4>Patient-Centered Care</h4>
      <h5>Focused on your comfort and well-being</h5>
    </div>
  </div>

  <div className="col-md-4">
    <div className="box">
      <i className="fas fa-globe"></i>
      <h4>International Standards</h4>
      <h5>Healthcare that meets global benchmarks</h5>
    </div>
  </div>

  <div className="col-md-4">
    <div className="box">
      <i className="fas fa-hand-holding-medical"></i>
      <h4>Personalized Treatment</h4>
      <h5>Tailored medical plans for every patient</h5>
    </div>
  </div>

  <div className="col-md-4">
    <div className="box">
      <i className="fas fa-smile"></i>
      <h4>Friendly Atmosphere</h4>
      <h5>Warm and welcoming environment</h5>
    </div>
  </div>

  <div className="col-md-4">
    <div className="box">
      <i className="fas fa-ambulance"></i>
      <h4>Emergency Support</h4>
      <h5>Quick response and 24/7 availability</h5>
    </div>
  </div>

  <div className="col-md-4">
    <div className="box">
      <i className="fas fa-graduation-cap"></i>
      <h4>Continuous Learning</h4>
      <h5>Doctors committed to ongoing education</h5>
    </div>
  </div>
  <div className="col-md-4">
    <div className="box">
      <i className="fas fa-clinic-medical"></i>
      <h4>Comprehensive Facilities</h4>
      <h5>All medical services under one roof</h5>
    </div>
  </div>
  <div className="col-md-4">
    <div className="box">
      <i className="fas fa-users"></i>
      <h4>Family-Friendly Care</h4>
      <h5>Services tailored for all age groups</h5>
    </div>
  </div>

  <div className="col-md-4">
    <div className="box">
      <i className="fas fa-shield-alt"></i>
      <h4>Trusted Safety</h4>
      <h5>Strict hygiene and patient safety protocols</h5>
    </div>
  </div>
<div className="col-md-4">
    <div className="box">
      <i className="fas fa-phone-volume"></i>
      <h4>24/7 Support</h4>
      <h5>Always available to answer your needs</h5>
    </div>
  </div>



</div>
<div className="row">
    <div className="login text-center ">
        <div className="col-md-12">
                          <Link to="/login" className="nav-link "  onClick={gettop}> 
                           <button className="btn btn-danger w-100  m-2">
    <i className="fas fa-sign-in-alt"></i> Login
  </button>
                          </Link>

 
<Link to="/register" className="nav-link w-100"  onClick={gettop}> 
                           <button className="btn btn-danger w-100  m-2">
    <i className="fas fa-sign-in-alt"></i> Register
  </button>
                          </Link>
</div>
    </div>
</div>
</div>
        </div>
        </>
    )
}
export default  Reservations